"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StabilityDeposit = void 0;
const Decimal_1 = require("./Decimal");
/**
 * A Stability Deposit and its accrued gains.
 *
 * @public
 */
class StabilityDeposit {
    /**
     * Address of frontend through which this Stability Deposit was made.
     *
     * @remarks
     * If the Stability Deposit was made through a frontend that doesn't tag deposits, this will be
     * the zero-address.
     */
    // readonly frontendTag: string;
    /** @internal */
    constructor(initialSLSD, currentSLSD, collateralGain, psyReward) {
        this.initialSLSD = initialSLSD;
        this.currentSLSD = currentSLSD;
        this.collateralGain = collateralGain;
        this.psyReward = psyReward;
        // this.frontendTag = frontendTag;
        if (this.currentSLSD.gt(this.initialSLSD)) {
            throw new Error("currentSLSD can't be greater than initialSLSD");
        }
    }
    get isEmpty() {
        return (this.initialSLSD.isZero &&
            this.currentSLSD.isZero &&
            this.collateralGain.isZero
            && this.psyReward.isZero);
    }
    /** @internal */
    toString() {
        return (`{ initialSLSD: ${this.initialSLSD}` +
            `, currentSLSD: ${this.currentSLSD}` +
            `, collateralGain: ${this.collateralGain} }` +
            `, psyReward: ${this.psyReward} }`);
    }
    /**
     * Compare to another instance of `StabilityDeposit`.
     */
    equals(that) {
        return (this.initialSLSD.eq(that.initialSLSD) &&
            this.currentSLSD.eq(that.currentSLSD) &&
            this.collateralGain.eq(that.collateralGain) &&
            this.psyReward.eq(that.psyReward));
    }
    /**
     * Calculate the difference between the `currentSLSD` in this Stability Deposit and `thatSLSD`.
     *
     * @returns An object representing the change, or `undefined` if the deposited amounts are equal.
     */
    whatChanged(thatSLSD) {
        thatSLSD = Decimal_1.Decimal.from(thatSLSD);
        if (thatSLSD.lt(this.currentSLSD)) {
            return { withdrawSLSD: this.currentSLSD.sub(thatSLSD), withdrawAllSLSD: thatSLSD.isZero };
        }
        if (thatSLSD.gt(this.currentSLSD)) {
            return { depositSLSD: thatSLSD.sub(this.currentSLSD) };
        }
    }
    /**
     * Apply a {@link StabilityDepositChange} to this Stability Deposit.
     *
     * @returns The new deposited SLSD amount.
     */
    apply(change) {
        if (!change) {
            return this.currentSLSD;
        }
        if (change.withdrawSLSD !== undefined) {
            return change.withdrawAllSLSD || this.currentSLSD.lte(change.withdrawSLSD)
                ? Decimal_1.Decimal.ZERO
                : this.currentSLSD.sub(change.withdrawSLSD);
        }
        else {
            return this.currentSLSD.add(change.depositSLSD);
        }
    }
}
exports.StabilityDeposit = StabilityDeposit;
//# sourceMappingURL=StabilityDeposit.js.map